export default __webpack_public_path__ + "static/media/flag-united-states-minor-outlying-islands.0d34f81b.svg";